// The kanban board: columns (To Do / In Progress / QA / Done) rendered from the
// learner's live board state (GET /api/simulations/:slug/board). Clicking a card
// opens the ticket.
import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBoard } from "../../features/simulation/simulationSlice";
import { useSimulation } from "./SimulationContext";
import { Avatar, Label, TypeIcon } from "./mithraUi";

function Card({ card, onOpen, you }) {
  return (
    <div className="mi-card" onClick={() => onOpen(card)}>
      <div className="mi-card-labels">
        {card.labels.map((l) => (
          <Label key={l} text={l} />
        ))}
      </div>
      <div className="mi-card-title">{card.title}</div>
      <div className="mi-card-foot">
        <TypeIcon type={card.type} />
        <span className="mi-key">{card.key}</span>
        {you && <Avatar person={you} size="sm" />}
        <span className="mi-sp" title="Story points">
          {card.storyPoints}
        </span>
      </div>
    </div>
  );
}

function MithraBoard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { slug, company, columns, you } = useSimulation();
  const { board } = useSelector((s) => s.simulation);

  useEffect(() => {
    dispatch(getBoard(slug));
  }, [dispatch, slug]);

  const cards = (board && board.cards) || [];
  const cols = (board && board.columns) || columns;
  const base = `/simulations/${slug}`;

  const open = (card) => navigate(`${base}/ticket/${card.key}`);
  const byColumn = (key) => cards.filter((c) => c.status === key);
  const doneCount = cards.filter((c) => c.status === "done").length;

  return (
    <div>
      <div className="mi-crumbs">
        <Link to={base}>Projects</Link> / {company.projectName}
      </div>
      <div className="mi-board-head">
        <div className="mi-board-title">{company.sprint}</div>
      </div>
      <div className="mi-board-sub">
        {company.projectKey} board · {doneCount}/{cards.length} complete ·{" "}
        <span title="Assignee">
          {you && <Avatar person={you} size="sm" />} you
        </span>
      </div>

      <div className="mi-columns">
        {cols.map((col) => {
          const items = byColumn(col.key);
          return (
            <div className="mi-col" key={col.key}>
              <div className="mi-col-head">
                <span>{col.title}</span>
                <span className="mi-col-count">{items.length}</span>
              </div>
              {items.map((card) => (
                <Card key={card.key} card={card} onOpen={open} you={you} />
              ))}
              {items.length === 0 && <div className="mi-empty">No issues</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MithraBoard;
